// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store/index";
import VueScrollTo from "vue-scrollto";
import VueResource from "vue-resource";
import VeeValidate from "vee-validate";
import VeeValidatePortuguese from "vee-validate/dist/locale/pt_BR";
import VueTheMask from "vue-the-mask";
import VueTooltip from "vue-directive-tooltip";
import vSelectPage from "v-selectpage";
import ActionCableVue from "actioncable-vue";
import VueAnalytics from "vue-analytics";
import Toasted from "vue-toasted";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";

//Awesome icons component
import "./plugins/vue-awesome";

import actionCable from "@/utils/actionCable";

import "@/settings/baseComponents";

import "vue-directive-tooltip/css/index.css";

Vue.use(Toasted, {
  position: "bottom-center",
  duration: 5000,
  singleton: true,
  theme: "bubble"
});

Vue.use(VueAnalytics, {
  id: "UA-109800326-1",
  commands: {
    trackName(name = "unknown") {
      this.$ga.event("cliente", "click", name);
    }
  }
});

Vue.use(ActionCableVue, {
  debug: true,
  debugLevel: "error",
  connectionUrl: actionCable.buildURL(),
  connectImmediately: false
});

Vue.use(vSelectPage, {
  language: "en"
});
Vue.use(VueTooltip);
Vue.use(VueResource);
Vue.use(VueTheMask);
Vue.use(VeeValidate, {
  locale: "pt_BR",
  dictionary: {
    pt_BR: VeeValidatePortuguese
  }
});

Vue.use(VueScrollTo);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});

if (process.env.NODE_ENV === "production")
  Sentry.init({
    dsn:
      "https://fd495ec754204013961a06cf0e5731b3@o287049.ingest.sentry.io/5203103",
    integrations: [
      new Integrations.Vue({
        Vue,
        attachProps: true
      })
    ]
  });



// WEBPACK FOOTER //
// ./src/main.js